import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'COPModeloItem'

const GetAll = (copTypeId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/${copTypeId}`, data, config)
const Update = (copTypeId, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/${copTypeId}`, data, config)

const COPTypeItemRepository = {
  GetAll,
  Update
}

export default COPTypeItemRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/coptypeitem.js